import React, { useState, useEffect } from "react";
import TreeNode from "./TreeNode";
import { parseFileListToTree, nestTreeData } from "../utils/fileUtils";

const FileTree = ({ files, onSelectFile }) => {
  const [treeData, setTreeData] = useState([]);

  // Parse files to tree structure when the files list changes
  useEffect(() => {
    if (files && files.length > 0) {
      const flatTree = parseFileListToTree(files); // Get flat structure
      const nestedTree = nestTreeData(flatTree); // Convert flat to nested
      setTreeData(nestedTree);
    }
  }, [files]);

  return (
    <div style={{ height: "100%", overflowY: "auto" }}>
      {treeData.map((node) => (
        <TreeNode key={node.id} node={node} onSelectFile={onSelectFile} />
      ))}
    </div>
  );
};

export default FileTree;
